import { type ChangeEvent, useCallback } from 'react'
import { type ControllerRenderProps } from 'react-hook-form'

import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useStatusCheckDetailsContext } from 'context/status-checks/StatusCheckDetailsContext'

/**
 * Provides an onChange handler for AWS monitor URL fields. Callback resets
 * the status check validation states when the monitor URL changes.
 */
export function useAwsMonitorUrlFieldOnChangeHandler() {
  const {
    setIsStatusCheckConnectionValidated,
    setIsStatusCheckEvaluationValidated
  } = useStatusCheckDetailsContext()

  return useCallback(
    (field: ControllerRenderProps<StatusCheckFormValues, 'monitorUrl'>) =>
      (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setIsStatusCheckConnectionValidated(false)
        setIsStatusCheckEvaluationValidated(false)

        field.onChange(event)
      },
    [setIsStatusCheckConnectionValidated, setIsStatusCheckEvaluationValidated]
  )
}
